import React from 'react'
import SetOrgExpenseReportCycle from 'src/app/SetOrgExpenseReportCycle/SetOrgExpenseReportCycle'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { setOrgExpenseReportCycleRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const SetOrgExpenseReportCycleAppRoute: AppRoute = {
  id: AppLocation.SetOrgExpenseReportCycle,
  routeProps: setOrgExpenseReportCycleRouteProps,
  component: <SetOrgExpenseReportCycle />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default SetOrgExpenseReportCycleAppRoute
